'use es6';

import { isFromVisitor } from 'conversations-message-history/common-message-format/operators/senderTypeComparators';
import { isTypingMessage } from 'conversations-message-history/typing-indicator/operators/isTypingMessage';
export const isVisitorTypingMessage = message => isTypingMessage(message) && isFromVisitor(message);